import React, { Component } from 'react'
import styled from 'styled-components'
import { media } from 'styled-bootstrap-grid'
import TextInput from 'components/UI/TextInput'
import Link from 'components/UI/Link'
import ROUTES_PATH from 'routes/routePath'
import { Button } from '../../UI/Button'
import { AppState } from '../../../store'
import { Dispatch } from '../../../store/types'
import { bindActionCreators } from 'redux'
import { changePasswordByEmail, restPassword } from '../../../ducks/auth/operations'
import { connect } from 'react-redux'
import { handleErrorMessageAlert } from 'components/UI/Alert'
import { passwordValidation } from '../../../utils/helpers'

interface State {
  email: string
  code: string
  password: string
  isSend: boolean,
  showNext: boolean
  errors: {
    email: string | null
    code: string | null
    password: string | null
  }
}
class ResetPasswordForm extends Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = {
      email: '',
      code: '',
      password: '',
      errors: {
        email: null,
        code: null,
        password: null
      },
      isSend: false,
      showNext: false
    }
  }

  componentDidUpdate = (prevProps: Props, prevState: State) => {
    const isProcessed = prevProps.isProcessing && !this.props.isProcessing
    if (isProcessed && this.props.errorMessage) {
      handleErrorMessageAlert(this.props.errorMessage)
    }
    if (isProcessed && this.state.isSend && !this.props.errorMessage) {
      this.setState({ showNext: true })
    }
  }

  componentDidMount(): void {
    const url = window.location.href
    const urlArray = url.split('?')
    const param = urlArray[urlArray.length - 1].split('=')
    const value = param[param.length - 1]
    if (urlArray.length > 1) {
      this.setState({ showNext: true })
      console.log('code', value)
      // this.onUpdate('code', value)
      this.setState((prevState: State) => ({
        ...prevState,
        code: value
      }))
    }
  }

  onUpdate = (name: string, value: string) => {
    this.setState((prevState: State) => ({
      ...prevState,
      [name]: value
    }))
  }
  resetPassword = () => {
    // this.setState({ showNext: !this.state.showNext })
    // return
    // tslint:disable-next-line:no-shadowed-variable
    const errors = this.validate(['email'])
    if (!errors.email) {
      const { restPassword } = this.props
      const { email, isSend } = this.state
      this.setState({ isSend: !isSend })
      restPassword(email)
    }
  }
  sendCode = () => {
    // tslint:disable-next-line:no-shadowed-variable
    const errors = this.validate(['code', 'password'])
    if (!errors.code && !errors.password) {
      const { changePasswordByEmail } = this.props
      const { code, password, isSend } = this.state
      this.setState({ isSend: !isSend })
      // @ts-ignore
      changePasswordByEmail(code, password)
    }
  }
  backToEmail = () => {
    const { showNext } = this.state
    this.setState({ showNext: !showNext })
  }
  validate = (fieldsList: Array<string>) => {
    const { email, code, password } = this.state
    const errors: any = {}
    if (fieldsList.includes('email')) {
      if (!email) {
        errors.email = 'Please enter email'
      }
    }
    if (fieldsList.includes('code')) {
      if (!code) {
        errors.code = 'Please enter code'
      }
    }
    if (fieldsList.includes('password')) {
      if (!password) {
        errors.password = 'Please enter new password'
      } else if (passwordValidation(password)) {
        // password.length < 8
        // errors.password = 'The new password length is too small. Please try again.'
        errors.password =
          'Please check your new password. It must be longer 8 and include upper letters, ' +
          'lower letters, and number' // 'The password length is too small. Please try again.'
      }
    }
    this.showAlertErrors(errors)
    this.setState({ errors })
    return errors
  }

  showAlertErrors = (errors: any) => {
    Object.keys(errors).forEach(prop => {
      if (errors[prop]) {
        handleErrorMessageAlert(errors[prop])
      }
    })
  }

  render() {
    const { showNext, email, code, errors } = this.state
    const { errorMessage } = this.props
    return (
      <FormWrapper>
        {showNext ? console.log('here', showNext) : console.log('there', showNext)}
        {!showNext ? (
          <>
            <FormContainer>
              <FormTitle>Reset Password</FormTitle>
              <Description>
                Please enter your email address and we will send you a link to
                be able to reset your password.
              </Description>
              <FormContent>
                <TextInput
                  name={'email'}
                  label={'Email Address'}
                  placeholder={'Enter Email Address'}
                  handleChange={this.onUpdate}
                  errorLabel={errors.email || errorMessage || ''}
                />
              </FormContent>
            </FormContainer>
            <FormFooter>
              <Link variant={'text'} to={ROUTES_PATH.SIGN_IN}>
                Back to Sign In
              </Link>
              <Button variant={'default'} onClick={this.resetPassword}>
                Reset Password
              </Button>
              {/*<Link variant={'default'} to={ROUTES_PATH.CHECK_EMAIL}>*/}
              {/*  Reset Password*/}
              {/*</Link>*/}
            </FormFooter>
          </>
        ) : (
          <>
            <FormContainer>
              <FormTitle>Reset Password</FormTitle>
              <Description>{email}</Description>
              {console.log(code)}
              <FormContent>
                <TextInput
                  name={'code'}
                  label={'Code'}
                  placeholder={'code'}
                  value={code || ''}
                  handleChange={this.onUpdate}
                  errorLabel={errors.code || ''}
                  tooltipText={'Password reset code received by email'}
                />
              </FormContent>
              <FormContent>
                <TextInput
                  name={'password'}
                  label={'New password'}
                  type={'password'}
                  placeholder={'******'}
                  handleChange={this.onUpdate}
                  errorLabel={errors.password || ''}
                  tooltipText={'Account password. (Minimum length of 8 and must have minimum of 2 of lowercase, uppercase, numeric or other. Retry and History max is 10)'}
                />
              </FormContent>
            </FormContainer>
            <FormFooter>
              <Button variant={'text'} onClick={this.backToEmail}>
                Try another email
              </Button>
              <Button variant={'default'} onClick={this.sendCode}>
                Reset Password
              </Button>
              {/*<Link variant={'default'} to={ROUTES_PATH.CHECK_EMAIL}>*/}
              {/*  Reset Password*/}
              {/*</Link>*/}
            </FormFooter>
          </>
        )}
      </FormWrapper>
    )
  }
}

type StateProps = ReturnType<typeof mapStateToProps>
type DispatchProps = ReturnType<typeof mapDispatchToProps>
type Props = StateProps & DispatchProps // & ResetPasswordFormProps

const mapStateToProps = (state: AppState) => ({
  errorMessage: state.auth.errors.resetPassword,
  isProcessing: state.auth.isPasswordChanging
})

const mapDispatchToProps = (dispatch: Dispatch) =>
  bindActionCreators({ restPassword, changePasswordByEmail }, dispatch)

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ResetPasswordForm)
// export default ResetPasswordForm

const FormWrapper = styled.div`
  ${media.xs`
    min-width: 100%;
  `}
  ${media.sm`
    min-width: 100%;
  `}
  ${media.md`
    min-width: 640px;
  `}
`
const FormContainer = styled.div`
  background: #fff;
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.3);
  padding: 40px 40px 20px 40px;
  margin-bottom: 1.25rem;

  ${media.xs`
      padding: 20px;
  `}
`
const FormFooter = styled.div`
  display: flex;
  justify-content: space-between;
`
const FormContent = styled.div``

const FormTitle = styled.div`
  font-size: 30px;
  font-weight: 600;
  color: #152735;
  text-align: center;
  padding: 0.5rem 0 2rem;
`

const Description = styled.p`
  font-size: 15px;
  font-weight: 600;
  color: #585d64;
  text-align: center;
  max-width: 435px;
  margin: 0 auto 2rem;
`
